"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
(0, manifest_1.registerSection)({
    type: 'spacer', label: 'Spacer / divider', icon: 'minus', category: 'layout',
    settingsSchema: zod_1.z.object({
        height: zod_1.z.number().int().min(0).max(200).default(48),
        divider: zod_1.z.boolean().default(false),
        bgColor: zod_1.z.string().optional(),
    }),
    defaults: () => ({ height: 48, divider: false }),
    fields: [
        { name: 'height', label: 'Height (px)', control: 'number', min: 0, max: 200 },
        { name: 'divider', label: 'Show divider line', control: 'toggle' },
        { name: 'bgColor', label: 'Background colour', control: 'color' },
    ],
});
//# sourceMappingURL=spacer.js.map